import { render, staticRenderFns } from "./CategoryOrders.vue?vue&type=template&id=4424f146"
import script from "./CategoryOrders.vue?vue&type=script&lang=js"
export * from "./CategoryOrders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports